import { api } from "@/lib/utils/api";
import { RootState } from "@/store";
import {
  IUserKeyValue,
  setUserData,
  updateUserData,
} from "@/store/user-data-slice";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useLoading from "./useLoading";
import { toast } from "@/components/ui/use-toast";

const useUserData = () => {
  const {
    refetch: fetchUserData,
    error: fetchUserDataError,
    isLoading: isUserDataLoading,
  } = api.account.getUserData.useQuery(undefined, { enabled: false });
  const { loaded, userData } = useSelector(
    (state: RootState) => state.userData
  );
  const dispatch = useDispatch();
  const { setIsLoading } = useLoading();

  const fetchData = async () => {
    const { data: fetchedUserData } = await fetchUserData();
    if (fetchedUserData) {
      dispatch(setUserData({ userData: fetchedUserData }));
    }
  };

  const updateUserDataClient = (values: IUserKeyValue) => {
    dispatch(updateUserData({ values }));
  };

  useEffect(() => {
    if (!loaded) {
      fetchData();
    }
  }, [loaded]);

  useEffect(() => {
    setIsLoading(isUserDataLoading);
  }, [isUserDataLoading]);

  useEffect(() => {
    if (fetchUserDataError) {
      toast({
        variant: "destructive",
        description: fetchUserDataError.message,
      });
    }
  }, [fetchUserDataError]);

  return { userData, updateUserDataClient };
};

export default useUserData;
